import React,{Component} from 'react';
import Button from '@material-ui/core/Button';
import {history} from '../../../shared/configure-store';
import {connect} from 'react-redux';
import {RootActions} from '../../../shared/root-action';
import Logo from '../../../images/logo-black.png';
import Copyright from '../../presentational/copyright';
import {toast, ToastContainer} from 'react-toastify';
import {bindActionCreators} from 'redux';
import Api from '../../../libraries/api';
import ReactToPrint from 'react-to-print';
import language from "../../../libraries/label-lang";
import QRCode from 'qrcode.react';
import moment from "moment/moment";

require('dotenv').config();

class ReservationNote extends Component {
    constructor(props) {

        super(props);

        this.state = {
            loading: true,
            reservation_date: '',
            company_name: '',
            primary_address: '',
            primary_city: '',
            primary_state: '',
            contact_name: '',
            contact_phone_office: '',
            contact_phone_cell: '',
            contact_email: '',
            warehouse: '',
            warehouse_address: '',
            products: [],

            data: [],

            productsNote:[]
        };
    }

    componentDidMount() {
        document.title = 'Fresh Factory - Berhasil';

        this.setState({
            loading: true,
            productsNote:[]
        });
        Api.get('/reservation/nota?reservationId='+this.props.match.params.id).then(resp => {

            if (resp.data) {

                let data = resp.data;

                Api.get('/reservations/'+this.props.match.params.id).then(resp1 => {
                    let data2 = resp1.data;
                    let generateData = [];
                    let nX = {};
                    let countNx = 0;
                    data.generateData = [];
                    if(data2 && data2.SKU && data2.SKU.length){
                        data.products.map((i,ind)=>{
                            if(i.sku_number){
                                let locker = '';
                                data2.SKU.map(i2=>{
                                    if(i2.skuNumber == i.sku_number){
                                        let all = i2.iku.filter((item) => {
                                            if (item && item.warehouse) {
                                                let nW = item.warehouse.split('/');
                                                item.sku = i.sku_number;
                                                item.warehouse = nW[0];
                                                item.slot = nW[1]+'/'+nW[2]+'/'+nW[3];
                                                return item;
                                            }
                                            else{
                                                return;
                                            }
                                        });

                                        all.map(item=>{
                                            if(item) {
                                                if(nX[countNx] && Object.keys(nX[countNx]).length != 3 ){
                                                    nX[countNx].push(item);
                                                }
                                                else if (nX[countNx] && Object.keys(nX[countNx]).length == 3 ){
                                                    countNx++;
                                                    nX[countNx] = [
                                                        item,{name:'split'}
                                                    ];
                                                }
                                                else{
                                                    nX[countNx] = [
                                                        item,{name:'split'}
                                                    ];
                                                }
                                            }
                                        });

                                        i.IKU = all;
                                        locker = i2.iku[0] && i2.iku[0].lockerSize ? i2.iku[0].lockerSize : '-';
                                    }
                                });

                                i.lockerSize = locker;
                            }
                            if(data.products.length-1 == ind){
                            }
                        });

                        if(nX && Object.keys(nX).length){
                            Object.keys(nX).map(key=>{
                                if(nX[key] && nX[key].length){
                                    generateData.push(nX[key]);
                                    data.generateData.push(nX[key]);
                                }
                            });
                        }
                    }
                    else{
                        data.products.map(i=>{
                            if(i.sku_number){
                                i.lockerSize = '-';
                            }
                        })
                    }

                    this.setState({
                        loading: false,
                        reservation_id: this.props.match.params.id,
                        data: data,
                        reservation_date: data.reservation_date,
                        company_name: data.company_name,
                        primary_address: data.primary_address,
                        primary_city: data.primary_city,
                        primary_state: data.primary_state,
                        contact_name: data.contact_name,
                        contact_phone_office: data.contact_phone_office,
                        contact_phone_cell: data.contact_phone_cell,
                        contact_email: data.contact_email,
                        warehouseNote: data.warehouse,
                        warehouse_address: data.warehouse_address,
                        products: data.products,
                        productsNote: data.generateData //data.products,
                    },()=>{
                    });

                }).catch(err => {

                    this.setState({
                        loading: false,
                    });
                });

                // this.setState({
                //     loading: false,
                //     reservation_id: this.props.match.params.id,
                //     data: data,
                //     reservation_date: data.reservation_date,
                //     company_name: data.company_name,
                //     primary_address: data.primary_address,
                //     primary_city: data.primary_city,
                //     primary_state: data.primary_state,
                //     contact_name: data.contact_name,
                //     contact_phone_office: data.contact_phone_office,
                //     contact_phone_cell: data.contact_phone_cell,
                //     contact_email: data.contact_email,
                //     warehouse: data.warehouse,
                //     warehouse_address: data.warehouse_address,
                //     products: data.products,
                // });
            }else {
                this.setState({
                    loading: false,
                    reservation_id: null,
                });
            }
        }).catch(err => {
            this.setState({
                loading: false,
            });
            this.showMessage(false, err.message);
        });
    }

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleGo  = (link) => {

        history.push(link);
    };


    render() {

        let lang = {};
        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        return (
            <main className='success'>
                <section className='my-auto'>
                    <div className='container'>
                        <div className='row justify-content-center'>
                            <div className='col-md-10 col-lg-8 text-center'>
                                {/*<img src={Logo} alt='logo' className='img-logo' />*/}
                                {/*<h1 className='text-big mb-5'>{text.note_heading}</h1>*/}
                            </div>
                        </div>
                        {
                            this.state.reservation_id === null ?
                                <div className='row justify-content-center'>
                                    <div className='col-md-10 col-lg-8'>
                                    </div>
                                </div>
                                :
                                <div className='row justify-content-center'>
                                    {this.state.loading ? (
                                        <div className='col-12'>
                                            <i className='fa fa-spinner fa-spin'>&nbsp; </i>
                                        </div>
                                    ) : (
                                        <div className='col-md-10 col-lg-8'>
                                            <PrintLabels lang={this.props.toggle_set_lang} data={this.state.data} ref={el => (this.componentRef = el)} />
                                        </div>
                                    )}
                                    {this.state.loading ? '':(
                                        <div className='col-md-10 col-lg-8 mt-4'>

                                            <div className='row mt-4'>
                                                <div className='col-md-6'>

                                                    <ReactToPrint
                                                        trigger={() =>  <Button
                                                            variant='contained'
                                                            className='btn-link'
                                                        ><i className="fas fa-print mr-2" > </i>
                                                            {/*{text.button_print}*/}
                                                            {text.button_print_delivery_note}
                                                        </Button>}
                                                        content={() => this.componentRef}
                                                    />
                                                </div>
                                                <div className='col-md-6 text-md-right'>
                                                    {/*<Button*/}
                                                    {/*    variant='contained'*/}
                                                    {/*    color='primary'*/}
                                                    {/*    className='btn-link mr-3'*/}
                                                    {/*    onClick={() => this.handleGo('/reservation-success/'+this.props.match.params.id)}*/}
                                                    {/*>*/}
                                                    {/*    {text.button_back}*/}
                                                    {/*</Button>*/}
                                                    <Button
                                                        variant='contained'
                                                        color='primary'
                                                        onClick={() => this.handleGo('/')}
                                                    >
                                                        {text.button_done}
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                        )}
                                </div>
                        }

                    </div>
                </section>
                <footer className='mt-5'>
                    <p className='text-center absolute-bottom'><Copyright /></p>
                </footer>
                <ToastContainer autoClose={false} />
            </main>
        );
    }
}

class PrintLabels extends Component {
    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            email: '',
            data: this.props.data,
            lang: this.props.lang,
            products: this.props.data.products ? this.props.data.products : [],
            productsNote: this.props.data.generateData ? this.props.data.generateData : [],
        };
    }

    componentDidMount() {
        document.title = 'Fresh Factory - Berhasil';

    }

    render() {

        let lang = {};
        if(this.state.lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;
        return(
            <table width="100%" cellPadding='3'>
                <thead>
                    <tr>
                        <th colSpan={3} className="text-center">
                            <img src={Logo} alt='logo' className='img-logo' />
                            <p className={this.state.data.isShuttle ? 'text-big mb-0' : 'text-big'}>{text.label_nota_delivery}</p>
                            {this.state.data.isShuttle === 1 &&
                                <p className="text-medium">(Shuttle Services)</p>
                            }
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <table width="700px" style={{margin:'auto'}}>
                                <thead>
                                <tr>
                                    <th className="text-left">
                                        <label className='p-10 label-note text-left'>{text.label_nota}</label>
                                        <p className='p-12 mb-0'><strong>{this.state.data.nota}</strong></p>
                                        {/*<p className='p-12 text-grey'>{this.state.data.primary_address}, {this.state.data.primary_city}, {this.state.data.primary_state}</p>*/}
                                    </th>
                                    <th style={{textAlign: 'right'}} >
                                        {this.state.data.nota &&
                                        <QRCode
                                            size={100}
                                            value={this.state.data.nota}/>
                                        }
                                        <small className='p-8 text-grey d-block'>{this.state.data.nota}</small>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr className="text-left">
                                        <td width="50%">
                                            <label className='p-10 label-note text-left'>{text.label_company_only}</label>
                                            <p className='p-12 mb-0'><strong>{this.state.data.company_name}</strong></p>
                                            <p className='p-12 text-grey'>{this.state.data.primary_address}, {this.state.data.primary_city}, {this.state.data.primary_state}</p>
                                        </td>
                                        <td width="50%"></td>
                                    </tr>
                                    <tr className="text-left">
                                        <td width="50%">
                                            <label className='p-10 label-note'>{text.label_warehouses}</label>
                                            <p className='p-12'><strong>{this.state.data.warehouse}</strong></p>
                                        </td>
                                        <td width="50%">
                                            <label className='p-10 label-note'>{text.label_name_contact}</label>
                                            <p className='mb-0 p-12'><strong>{this.state.data.contact_name}</strong></p>
                                            <p className='p-12 text-grey'>{this.state.data.contact_email}/{this.state.data.contact_phone_office}/{this.state.data.contact_phone_cell}</p>
                                        </td>
                                    </tr>

                                    {this.state.data.isShuttle === 1 &&
                                        <tr className="text-left">
                                            <td colSpan='2' width='100%'>
                                                <div className='card-cream mb-0'>
                                                    <div className='row mx-auto py-4 align-items-center'>
                                                        <div className='col-11 text-left p-10 color-brown-grey'>
                                                            <label className='mb-0'><i className='fas fa-warehouse pr-2'> </i> {text.label_warehouse_destination_address}</label>
                                                            <p className='p-12 color-gunmetal mb-0'>{this.state.data.HQ_address1+' '+this.state.data.HQ_address2+', '+this.state.data.HQ_city+', '+this.state.data.HQ_state}</p>
                                                        </div>
                                                        <div className='col-1'>
                                                            <i className='fas fa-map-marker-alt color-reddish'> </i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    }

                                    <tr className="text-left">
                                        <td colSpan='2' width='100%'>
                                            <div className='card-cream'>
                                                <div className='row mx-auto py-4 align-items-center'>
                                                    <div className='col-11 text-left p-10 color-brown-grey'>
                                                        <label className='mb-0'><i className='fas fa-warehouse pr-2'> </i> {text.label_warehouse_address}</label>
                                                        <p className='p-12 color-gunmetal mb-0'>{this.state.data.warehouse_address1+' '+this.state.data.warehouse_address2+', '+this.state.data.warehouse_city+', '+this.state.data.warehouse_state}</p>
                                                    </div>
                                                    <div className='col-1'>
                                                        <i className='fas fa-map-marker-alt color-reddish'> </i>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    {this.state.data.isShuttle === 1 ? (
                                            <tr className="text-left">
                                                <td colSpan='2' width='100%'>
                                                    <div className='card-cream green-bg mt-0'>
                                                        <div className='row mx-auto py-3 align-items-center'>
                                                            <div className='col-12 text-left p-10 color-white with-fa-abs'>
                                                                <i className='fas fa-exclamation-circle'> </i>
                                                                <p className='p-12 p-normal mb-0'>{text.label_delivery_HQ} : <strong>{moment(this.state.data.shuttle_received_deadline,'YYYY-MM-DD HH:mm:ss').format('DD MMMM YYYY')}</strong></p>
                                                                <p className='p-12 p-normal mb-0'>{text.label_delivery_cost} : <strong>Rp 30.000 / Pengiriman</strong></p>
                                                                <p className='p-12 p-normal mb-0'>{text.label_delivery_must_received} : <strong>{moment(this.state.data.shuttle_sent_date,'YYYY-MM-DD HH:mm:ss').format('DD MMMM YYYY')}</strong></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            <tr className="text-left">
                                                <td width="50%">
                                                    <h3 className='p-18'><strong>{text.label_time}</strong></h3>
                                                    <p className='p-12'>{this.state.data.reservation_date}</p>
                                                </td>
                                            </tr>
                                        )
                                    }
                                    <tr className="text-left">
                                        <td colSpan='3' width='100%'>
                                            <div className='card-nota d-block'>
                                                <table width='100%'>
                                                    <tbody>
                                                        <tr>
                                                            <th colSpan={3}>
                                                                <h3 className='p-18'><strong>{text.reservation_product}</strong></h3>
                                                            </th>
                                                            {/*<th></th>*/}
                                                            {/*<th></th>*/}
                                                        </tr>
                                                        <tr>
                                                            <td><p className='p-10 mb-0'>{text.label_product}</p></td>
                                                            <td><p className='p-10 mb-0 text-center'>{text.label_quantity}</p></td>
                                                            <td><p className='p-10 mb-0 text-right'>{text.label_sku}</p></td>
                                                        </tr>
                                                    <tr>
                                                        <td colSpan={3} width="100%"><hr/></td>
                                                    </tr>
                                                    {
                                                        this.state.products.length > 0 &&
                                                        this.state.products.map(function (item) {
                                                            return ( <tr key={item.sku_number}>
                                                                    <td width="33%">
                                                                        <p className='p-12'>{item.name}</p>
                                                                    </td>
                                                                    <td width="33%">
                                                                        <p className='p-12 text-center'>{item.quantity}</p>
                                                                    </td>
                                                                    <td width="33%">
                                                                        <p className='p-12 text-right'>{item.sku_number}</p>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    </tbody>

                                                </table>

                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan='2' width='100%'>
                                            <div className='card-cream p-3'>
                                                <p className='p-10 color-gunmetal mb-0'>*{text.note_text}</p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                        <table width="700px" style={{margin:'auto'}}>
                            <thead>
                            <tr>
                                <th colSpan={3} className="text-left" style={{'paddingBottom': '15px'}}>
                                    <h3 className='p-18'><strong>{text.label_iku}</strong></h3>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr >
                                    <td colSpan={2}>
                                        <table width='100%'>
                                            <thead><tr><th colSpan={2}>&nbsp;</th></tr></thead>
                                            <tbody>
                                            {
                                                this.state.productsNote ?
                                                    this.state.productsNote.map((row, index)=>{
                                                        return(
                                                            <tr key={index+"_tab" }>
                                                                {
                                                                    row.map((n,ni)=>{
                                                                        if(ni == 1 && row.length < 3){
                                                                            return (
                                                                                <td
                                                                                    colSpan={1}
                                                                                    key={(n.ikuId ? n.ikuId :'manual')+'_'+ni}
                                                                                    width="49%"
                                                                                    style={{
                                                                                        'borderTop': '2px dashed silver',
                                                                                        'borderBottom': '2px dashed silver',
                                                                                        // 'border-left': '2px dashed silver'
                                                                                    }}>

                                                                                    <div style={{
                                                                                        transform: 'rotate(90deg)',
                                                                                        // 'borderTop': '2px dashed silver',
                                                                                        position: 'relative',
                                                                                        height: '12px',
                                                                                        width: '12px',
                                                                                        top: '0px',
                                                                                        left: '0px'
                                                                                    }}>
                                                                                        <div style={{
                                                                                            position: 'absolute',
                                                                                            transform: 'rotate(360deg)',
                                                                                            left: '0px',
                                                                                            right: '0px',
                                                                                            top: '0px',
                                                                                            bottom: '0px',
                                                                                            width: '100px'
                                                                                        }}>potong disini</div>
                                                                                    </div>
                                                                                    <span style={{position: 'relative', top: '-79px'}}>potong disini</span>

                                                                                    <div className="col-12 mb-4">
                                                                                    </div>
                                                                                </td>
                                                                            );
                                                                        }
                                                                        if(ni == 0){
                                                                            return (
                                                                                <td
                                                                                    colSpan={1}
                                                                                    key={(n.ikuId ? n.ikuId :'manual')+'_'+ni}
                                                                                    width="49%"
                                                                                    style={{
                                                                                        'borderTop': '2px dashed silver',
                                                                                        'borderBottom': '2px dashed silver',
                                                                                        'borderRight': '2px dashed silver'
                                                                                    }}>
                                                                                    <span style={{position: 'relative', top: '-20px'}}>potong disini</span>
                                                                                    <div className="col-12 mb-4">
                                                                                        <p className="text-left mb-1">
                                                                                            <strong>IKU-{n.ikuId}</strong></p>
                                                                                        <p className="text-left mb-1">{n.productName} - {n.weight}</p>

                                                                                        <div className='card card-label'>
                                                                                            <div className='col-12 row p-0 m-0'>
                                                                                                <div className='' style={{width: '40%'}}>
                                                                                                    <p>{text.label_locker}</p>
                                                                                                    <p><strong>{n.lockerSize}</strong></p>
                                                                                                </div>
                                                                                                <div className='' style={{width: '60%'}}>
                                                                                                    <p>{text.label_warehouses}</p>
                                                                                                    <p><strong>{n.warehouse}/{n.slot}</strong></p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                            );
                                                                        }
                                                                        if(ni == 2) {
                                                                            return (
                                                                                <td
                                                                                    colSpan={1}
                                                                                    key={(n.ikuId ? n.ikuId :'manual')+'_'+ni}
                                                                                    width="49%"
                                                                                    style={{
                                                                                        'borderTop': '2px dashed silver',
                                                                                        'borderBottom': '2px dashed silver',
                                                                                        // 'border-left': '2px dashed silver'
                                                                                    }}>

                                                                                    <div style={{
                                                                                        transform: 'rotate(90deg)',
                                                                                        // 'borderTop': '2px dashed silver',
                                                                                        position: 'relative',
                                                                                        height: '12px',
                                                                                        width: '12px',
                                                                                        top: '45px',
                                                                                        left: '2px'
                                                                                    }}>
                                                                                        <div style={{
                                                                                            position: 'absolute',
                                                                                            transform: 'rotate(360deg)',
                                                                                            left: '0px',
                                                                                            right: '0px',
                                                                                            top: '0px',
                                                                                            bottom: '0px',
                                                                                            width: '100px'
                                                                                        }}>potong disini</div>
                                                                                    </div>
                                                                                    <span style={{position: 'relative', top: '-26px'}}>potong disini</span>

                                                                                    <div className="col-12 mb-4">
                                                                                        <p className="text-left mb-1">
                                                                                            <strong>IKU-{n.ikuId}</strong></p>
                                                                                        <p className="text-left mb-1">{n.productName} - {n.weight}</p>

                                                                                        <div className='card card-label'>
                                                                                            <div className='col-12 row p-0 m-0'>
                                                                                                <div className='' style={{width: '40%'}}>
                                                                                                    <p>{text.label_locker}</p>
                                                                                                    <p><strong>{n.lockerSize}</strong></p>
                                                                                                </div>
                                                                                                <div className='' style={{width: '60%'}}>
                                                                                                    <p>{text.label_warehouses}</p>
                                                                                                    <p><strong>{n.warehouse}/{n.slot}</strong></p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                            );
                                                                        }
                                                                    })
                                                                }
                                                            </tr>
                                                        );
                                                    })
                                                    : <tr><td colSpan={2}>Data Kosong</td></tr>
                                            }
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

const mapStateToProps = (state) => {

    return {

        profile_state: state.profile_state,

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(ReservationNote);